import {Dispatch} from 'react'
import {FACTURACION_TYPES} from '../../constants/facturacion.types'
import {
  CalculoArrayProductos,
  FacturacionAction,
  ProductosF,
} from '../../interfaces/facturacion.interface'
import * as validaciones from '../../utils/strings.utils'
import {State} from '../../reducers'
import * as validators from '../../utils/validaciones'
import {generalOpenModalError, generalOpenModalInfo} from '../general.actions'
import {roundToTwo} from '../../utils/numbers.utils'
import {calcularDescuentoGlobal, factorNetoDescuento} from '../../utils/descuentoGlobal'
import {
  LineaDte,
  aMonto,
  alcanzaElMinimoDelUnoPorCiento,
  ivaSobreBase,
  montosDeLinea,
  precioUnitarioNeto,
  redondear2,
  unoPorCiento,
} from '../../utils/calculo-dte'
import { processDetalleImpuestosHTML, procesOtrosImpuestosResumen, processOtrosImpuestosCalculo,getDigitosCalculables, isEmpresa3Digitos } from '../utils-documentos.actions'
import { facturacionFormClienteHandleChange } from './facturacionCliente.actions'

export const lineaDteFactura = (producto: any, sinIva: boolean): LineaDte => ({
  precio: producto?.precio,
  cantidad: producto?.cantidad,
  conIva: sinIva,
  tipoDescuento: producto?.tipoDescuento === 'porcentaje' ? 'Porcentaje' : 'Monto',
  descuento: producto?.descuento,
})

export const ivaIncluidoEnVenta = (venta: number): number =>
  redondear2(venta - precioUnitarioNeto(venta, true))

export const noGravadoUnitario = (producto: any): number => {
  const cantidad = aMonto(producto?.cantidad)
  const totalLinea = aMonto(producto?.total) + aMonto(producto?.cantidadDescuento)
  return cantidad > 0 ? totalLinea / cantidad : totalLinea
}

export const montoPropina = (montoTotalOperacion: number, cantidadPropina: any): number =>
  redondear2(redondear2(montoTotalOperacion) * aMonto(cantidadPropina))

export const sumaOperacionesBrutaFactura = (calculos: any): string =>
  redondear2(aMonto(calculos?.total) + aMonto(calculos?.descuentoGlobal)).toFixed(2)

// ******************************************************************************************
export const facturacionFormProductoHandleChange = (formProducto: ProductosF) => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_HANDLE_CHANGE,
  payload: formProducto,
})

export const facturacionFormProductoAddError = (formError: ProductosF) => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_SET_ERRORS,
  payload: formError,
})

export const facturacionFormProductoClear = () => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_CLEAR,
  payload: null,
})

export const facturacionArrayProductoAgregar = (producto: ProductosF) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_ADD,
  payload: producto,
})

export const facturacionArrayProductosSet = (productos: Array<ProductosF>) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SET_DATA,
  payload: productos,
})

export const facturacionArrayProductoDeleteOne = () => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_DELETE_ONE,
  payload: null,
})

export const facturacionArrayProductoClearAll = () => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_CLEAR_ALL,
  payload: null,
})

export const facturacionSetTotalDocRelacionado = (total: string) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SET_TOTAL_DOC_RELACIONADO,
  payload: total,
})

export const facturacionArrayProductoSetCalculos = (calculos: CalculoArrayProductos) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SET_CALCULOS,
  payload: calculos,
})

export const facturacionArrayProductoSelectOne = (i: number) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SELECT_ONE,
  payload: i,
})

export const facturacionArrayProductoEditar = () => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_EDIT,
  payload: null,
})

export const facturacionFormProductoHandleChangeEdit = (formProducto: ProductosF) => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_HANDLE_CHANGE_EDIT,
  payload: formProducto,
})

export const facturacionFormProductoAddErrorEdit = (formError: ProductosF) => ({ type: FACTURACION_TYPES.FORMPRODUCTOS_SET_ERRORS_EDIT, payload: formError})

export const facturacionDeleteServicios = () => ({ type: FACTURACION_TYPES.FACT_DELETE_SERVICIOS, payload: null})

// ******************************************************************************************
// * ACCIONES DE MODALES
export const facturacionModalsOpenEliminar = () => ({
  type: FACTURACION_TYPES.MODALELIMINAR_OPEN,
  payload: {activeEliminarUno: true},
})

export const facturacionModalsOpenQuitarTodo = () => ({
  type: FACTURACION_TYPES.MODALELIMINAR_OPEN,
  payload: {activeQuitarTodo: true},
})

export const facturacionModalsClose = () => ({
  type: FACTURACION_TYPES.MODALELIMINAR_CLOSE,
  payload: null,
})

export const facturacionOpenModalEditar = (i: number, producto: ProductosF) => ({
  type: FACTURACION_TYPES.MODALEDITAR_OPEN,
  payload: {productoSeleccionado: i, formProductosEdit: producto},
})

export const facturacionCloseModalEditar = () => ({
  type: FACTURACION_TYPES.MODALEDITAR_CLOSE,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const facturacionFormProductoHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const edit = getState().facturacion.modals.activeEditar
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'descripcion':
          if (!validaciones.validarRegexLetras(value)) return
          break
        case 'cantidad':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        case 'precio':
        case 'precioConIva':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        case 'tipoDescuento':
          break
        case 'descuento':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        default:
          break
      }
    }
    if (edit) dispatch(facturacionFormProductoHandleChangeEdit({[name]: value}))
    else dispatch(facturacionFormProductoHandleChange({[name]: value}))
  }

export const facturacionFormProductoUpdateCalculo =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const {productos: productosCatalogo} = getState().catalogos;
    const edit = getState().facturacion.modals.activeEditar
    const idDoc = getState().documentos.activeDoc?.idDoc
    let formProducto = edit
      ? getState().facturacion.formProductosEdit
      : getState().facturacion.formProductos;
    
    let { checkExentoImpuesto, checkVentasNoSujetas } = getState().facturacion.formCliente;
    let {cantidad, precio, descuento, tipoDescuento} = formProducto;
  
    let detalleTributos = "";
    let subtotal_ = 0,
      descuento_ = 0,
      total_ = 0,
      ventasGravadas_ = 0,
      impuesto1 = 0,
      totalImpuesto1 = 0,
      impuesto2 = 0,
      totalImpuesto2 = 0,
      totalConImpuesto1 = 0,
      totalConImpuesto1Desc = 0,
      otrosImpuestos = 0;

    if (idDoc === '01') {
      // * FACTURACIÓN CF
      const checkNoGravado = edit
        ? getState().facturacion.formProductosEdit?.checkNoGravado
        : getState().facturacion.formProductos?.checkNoGravado

      const sinIva = !!(checkExentoImpuesto || checkVentasNoSujetas)
      const montos = montosDeLinea(lineaDteFactura({precio, cantidad, descuento, tipoDescuento}, sinIva))

      if (cantidad && precio) {
        subtotal_ = montos.precioUni * aMonto(cantidad)
      }

      if (cantidad && precio && descuento && tipoDescuento) {
        descuento_ = montos.descuento
        total_ = montos.venta

        if (!sinIva && !checkNoGravado) {
          impuesto1 = 13
          totalImpuesto1 = ivaIncluidoEnVenta(total_)
        }

        const baseOtrosTributos = precioUnitarioNeto(subtotal_, true)
        otrosImpuestos += processOtrosImpuestosCalculo(productosCatalogo, idDoc, formProducto, baseOtrosTributos);
        detalleTributos = processDetalleImpuestosHTML(productosCatalogo, idDoc, formProducto, baseOtrosTributos);

        total_ += otrosImpuestos;
      }
    } else {
      const montos = montosDeLinea(lineaDteFactura({precio, cantidad, descuento, tipoDescuento}, false))

      if (cantidad && precio) {
        subtotal_ = redondear2(montos.precioUni * aMonto(cantidad))
      }

      if (cantidad && precio && descuento && tipoDescuento) {
        descuento_ = montos.descuento
        impuesto1 = 13
        total_ = montos.venta

        totalImpuesto1 = ivaSobreBase(montos.ventaExacta)

        impuesto2 = alcanzaElMinimoDelUnoPorCiento(total_) ? 1 : 0
        totalImpuesto2 = impuesto2 === 1 ? unoPorCiento(total_) : 0

        totalConImpuesto1 = redondear2(subtotal_ + totalImpuesto1)
        totalConImpuesto1Desc = redondear2(totalConImpuesto1 - descuento_)
      }
    }

    const body = {
      cantidadDescuento: roundToTwo(descuento_),
      subtotal: roundToTwo(subtotal_),
      total: roundToTwo(total_),
      impuesto1: String(impuesto1),
      totalImpuesto1: roundToTwo(totalImpuesto1),
      impuesto2: String(impuesto2),
      totalImpuesto2: roundToTwo(totalImpuesto2),
      totalConImpuesto1: roundToTwo(totalConImpuesto1),
      totalConImpuesto1Desc: roundToTwo(totalConImpuesto1Desc),
      ventasGravadas: roundToTwo(ventasGravadas_),
      otrosImpuestos: roundToTwo(otrosImpuestos),
      detalleTributos: detalleTributos,
    }
    if (edit) dispatch(facturacionFormProductoHandleChangeEdit(body))
    else dispatch(facturacionFormProductoHandleChange(body))
}

export const recalcularProductosSinIva = (arrayProductos: Array<ProductosF>, sinIva: boolean): Array<ProductosF> =>
  arrayProductos.map((prod: ProductosF) => {
    let subtotal_ = aMonto(prod.subtotal)
    const descuento_ = aMonto(prod.cantidadDescuento)
    let total_ = 0
    let impuesto1 = parseInt(prod.impuesto1!)
    let totalImpuesto1 = aMonto(prod.totalConImpuesto1)

    if (sinIva) {
      subtotal_ = precioUnitarioNeto(subtotal_, true)
      total_ = subtotal_ - descuento_
    } else {
      subtotal_ = aMonto(prod.cantidad) * aMonto(prod.precio)
      total_ = subtotal_ - descuento_
      impuesto1 = 13
      totalImpuesto1 = ivaIncluidoEnVenta(total_)
    }

    return {
      ...prod,
      subtotal: roundToTwo(subtotal_),
      total: roundToTwo(total_),
      impuesto1: roundToTwo(impuesto1),
      totalImpuesto1: roundToTwo(totalImpuesto1),
    }
  })

export const facturacionUpdateCalculosExentos =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    let arrayProductos = getState().facturacion.arrayProductos;
    let checkExentoImpuesto = getState().facturacion.formCliente.checkExentoImpuesto;

    if (arrayProductos?.length > 0) {
      dispatch(facturacionArrayProductosSet(recalcularProductosSinIva(arrayProductos, !!checkExentoImpuesto)))
    }
}


export const facturacionUpdateCalculosVentasNoSujetas =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    let arrayProductos = getState().facturacion.arrayProductos;
    let checkVentasNoSujetas = getState().facturacion.formCliente.checkVentasNoSujetas;

    if (arrayProductos?.length > 0) {
      dispatch(facturacionArrayProductosSet(recalcularProductosSinIva(arrayProductos, !!checkVentasNoSujetas)))
    }
}


export const facturacionFormProductoAddProducto =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const edit = getState().facturacion.modals.activeEditar
    let formProductos = edit
      ? getState().facturacion.formProductosEdit
      : getState().facturacion.formProductos
    let errorsFormProductos = edit
      ? getState().facturacion.errorsFormProductosEdit
      : getState().facturacion.errorsFormProductos

    // Validaciones
    errorsFormProductos.descripcion = validators.validacionEsRequerido(
      formProductos.descripcion!,
      errorsFormProductos.descripcion!,
      'Descripción',
      'requerida'
    )

    errorsFormProductos.cantidad = validators.validacionEsRequerido(
      formProductos.cantidad!,
      errorsFormProductos.cantidad!
    )
    if (!errorsFormProductos.cantidad)
      errorsFormProductos.cantidad = validators.validacionNumMinimo(formProductos.cantidad!, 0)
    if (!errorsFormProductos.cantidad)
      errorsFormProductos.cantidad = validators.validacionNumMaximo(
        formProductos.cantidad!,
        100000000000
      )

    errorsFormProductos.precio = validators.validacionEsRequerido(
      formProductos.precio!,
      errorsFormProductos.precio!
    )
    if (!errorsFormProductos.precio)
      errorsFormProductos.precio = validators.validacionNumMinimo(formProductos.precio!, 0)
    if (!errorsFormProductos.precio)
      errorsFormProductos.precio = validators.validacionNumMaximo(
        formProductos.precio!,
        100000000000
      )

    errorsFormProductos.tipoDescuento = validators.validacionEsRequerido(
      formProductos.tipoDescuento!,
      errorsFormProductos.tipoDescuento!
    )

    errorsFormProductos.descuento = validators.validacionEsRequerido(
      formProductos.descuento!,
      errorsFormProductos.descuento!
    )
    if (!errorsFormProductos.descuento)
      errorsFormProductos.descuento = validators.validacionNumMaximo(
        formProductos.descuento!,
        100000000000
      )

    // Validación de Descuento
    if (!errorsFormProductos.descuento) {
      const {tipoDescuento, precio, cantidad} = formProductos
      const {messageError, ms} = validacionDescuento(
        formProductos.descuento!,
        tipoDescuento!,
        precio!,
        cantidad!
      )
      if (messageError) {
        dispatch(generalOpenModalError(messageError))
        errorsFormProductos.descuento = ms
      }
    }
    // Fin de Validaciones

    if (edit) {
      dispatch(facturacionFormProductoAddErrorEdit(errorsFormProductos))
    } else {
      dispatch(facturacionFormProductoAddError(errorsFormProductos))
    }

    if (
      errorsFormProductos.descripcion ||
      errorsFormProductos.cantidad ||
      errorsFormProductos.precio ||
      errorsFormProductos.tipoDescuento ||
      errorsFormProductos.descuento
    )
      return

    if (edit) {
      dispatch(facturacionArrayProductoEditar())
      dispatch(generalOpenModalInfo('El producto fue editado satisfactoriamente.'))
    } else {
      await dispatch(facturacionArrayProductoAgregar({...getState().facturacion.formProductos}))
      await dispatch(facturacionFormProductoClear())
      dispatch(generalOpenModalInfo('Producto agregado correctamente.'))
    }
  }

export const facturacionCalculoTotalArrayProducto =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const arrayProductos = getState().facturacion.arrayProductos
    const userLogin = getState().userLogin
    const {productos: productosCatalogo} = getState().catalogos
    const idDoc = getState().documentos.activeDoc?.idDoc

    let descuentoGlobal = 0, descuentoGlobalError = ''
    let subtotal = 0, descuento = 0, total = 0, cantidad = 0, impuesto1 = 0,
      impuesto2 = 0, totalConImpuesto1 = 0, subTotalConImpuesto1 = 0, totalIvaPercibido=0, totalConRetecion = 0,
      totalRetencionRenta = 0, totalMontoOperacion = 0, totalPagar = 0, otrosImpuestos = 0, totalNoGravado = 0
    let resumenTributos:Array<any> = [];

    if (idDoc === '01') {
      const {checkContribuyente, checkExentoImpuesto, checkRetencion1, checkRetencionRenta, checkPropina, checkVentasNoSujetas} = getState().facturacion.formCliente
      if (arrayProductos.length > 0) {
        const productosGravados = arrayProductos.filter((p) => !p.checkNoGravado)
        const productosNoGravados = arrayProductos.filter((p) => p.checkNoGravado)

        // Subtotal = sumatoria de precio * cantidad (excluye no gravados)
        subtotal = productosGravados.reduce((a, b) => Number(a) + Number(b.subtotal), 0)
        // descuento = sumatoria de descuento (excluye no gravados)
        descuento = productosGravados.reduce((a, b) => Number(a) + Number(b.cantidadDescuento), 0)
        // cantidad = sumatoria de cantidades
        cantidad = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidad), 0)
        // totalNoGravado = sumatoria de productos no gravados
        totalNoGravado = productosNoGravados.reduce((a, b) => Number(a) + Number(b.total), 0)

        // Descuento global: se aplica sobre la venta neta de descuentos por item (los precios de la Factura incluyen IVA)
        // (subtotal - descuento por item; no incluye otros impuestos, igual que precioUni*cantidad-descuento en la API)
        const ventasNetas = productosGravados.reduce((a, b) => Number(a) + Number(b.subtotal) - Number(b.cantidadDescuento), 0)
        const calculoDescuento = calcularDescuentoGlobal(
          getState().facturacion.formDescuentoGlobal,
          checkExentoImpuesto || checkVentasNoSujetas ? 0 : ventasNetas,
          checkExentoImpuesto ? ventasNetas : 0,
          !checkExentoImpuesto && checkVentasNoSujetas ? ventasNetas : 0
        )
        descuentoGlobal = calculoDescuento.total
        descuentoGlobalError = calculoDescuento.error
        const factorDescuento = ventasNetas > 0 ? (ventasNetas - calculoDescuento.descuGravada) / ventasNetas : 1
        // Todos los items comparten tipo de venta: el descuento global total aplica a la base de los otros tributos porcentuales
        const factorOtrosTributos = factorNetoDescuento(ventasNetas, calculoDescuento.total)

        // Si no es exento de impuesto !== Escenario 7
        if(checkExentoImpuesto !== true) {
          if (checkVentasNoSujetas !== true) {
            impuesto1 = ivaIncluidoEnVenta(redondear2(subtotal - descuento - calculoDescuento.descuGravada))
          }

          // tipoEmpresa: 1 juridica, 2 Natural
          // tipoContribuyente: 1 grande, 2 mediano, 3 otros
          let tipoEmpresa = getState().catalogos.datosEmisor?.tipoEmpresa;
          let tipoContribuyente = getState().catalogos.datosEmisor?.tipoContribuyente;
          let isFacturaCF = getState().facturacion.formCliente.checkCF

          if(checkRetencionRenta && !isFacturaCF) {
            // totalRetencionRenta = sumatoria de todos los totales de servicios (excluye no gravados)
            totalRetencionRenta = productosGravados.reduce((a, b) =>  Number(a) + ((b.tipo === "s") ? Number(b.total) : 0), 0)
            totalRetencionRenta = precioUnitarioNeto(totalRetencionRenta * factorDescuento, true) * 0.1
          }
          if (checkRetencion1) {
            // Calculo de Retención 1% (excluye no gravados)
            // La retencion 1% se calcula sobre la venta gravada neta de descuento global
            total = productosGravados.reduce((a, b) =>  Number(a) + Number(b.total), 0) - calculoDescuento.descuGravada
            impuesto2 = alcanzaElMinimoDelUnoPorCiento(total) ? unoPorCiento(precioUnitarioNeto(total, true)) : 0
          }
        }

        // Otros impuestos (excluye no gravados)
        productosGravados.forEach((producto) => {
          const baseOtrosTributos = precioUnitarioNeto(producto.subtotal, true) * factorOtrosTributos
          otrosImpuestos += processOtrosImpuestosCalculo(productosCatalogo, idDoc, producto, baseOtrosTributos, false);
          resumenTributos = procesOtrosImpuestosResumen(productosCatalogo, idDoc, resumenTributos, producto, baseOtrosTributos);
        })

        resumenTributos.forEach((resum) => {
          resum.valor = redondear2(resum.valor);
        });

        total = subtotal - descuento - descuentoGlobal + otrosImpuestos
        // totalMontoOperacion = total (sin no gravados)
        totalMontoOperacion = total;
        // totalPagar = Monto de Operación - Retencion Renta + No Gravados
        totalPagar = totalMontoOperacion + totalIvaPercibido - totalRetencionRenta - impuesto2 + totalNoGravado
        if (checkPropina && userLogin?.propina?.propina_activa) {
          totalPagar = totalPagar + montoPropina(totalMontoOperacion, userLogin?.propina?.cantidad_propina)
        }
      }
    } else {
      if (arrayProductos.length > 0) {
        subtotal = arrayProductos.reduce((a, b) => Number(a) + Number(b.subtotal), 0)
        descuento = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidadDescuento), 0)
        total = arrayProductos.reduce((a, b) => Number(a) + Number(b.total), 0)
        cantidad = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidad), 0)
        impuesto1 = arrayProductos.reduce((a, b) => Number(a) + Number(b.totalImpuesto1), 0)

        impuesto2 = alcanzaElMinimoDelUnoPorCiento(total) ? unoPorCiento(total) : 0

        subTotalConImpuesto1 = subtotal + impuesto1

        totalConImpuesto1 = redondear2(subtotal + impuesto1 - descuento)

        totalConRetecion = redondear2(totalConImpuesto1 - impuesto2)
      }
    }

    if (totalPagar >= 25000) {
      // Si es mayor a la cantidad, remover el CF para hacer obligatorio el tipo de documento
      dispatch(facturacionFormClienteHandleChange({checkCF: false, validacionMonto25000: true}));
    } else {
      dispatch(facturacionFormClienteHandleChange({validacionMonto25000: false}));
    }

    dispatch(
      facturacionArrayProductoSetCalculos({
        subtotal: roundToTwo(subtotal),
        descuento: roundToTwo(descuento),
        total: roundToTwo(total),
        totalCantidad: String(cantidad),
        totalImpuesto1: roundToTwo(impuesto1),
        totalImpuesto2: roundToTwo(impuesto2),
        subTotalConImpuesto1: roundToTwo(subTotalConImpuesto1),
        totalConImpuesto1: roundToTwo(totalConImpuesto1),
        totalConRetecion: roundToTwo(totalConRetecion),
        totalIvaPercibido: roundToTwo(totalIvaPercibido),
        totalRetencionRenta: roundToTwo(totalRetencionRenta),
        totalMontoOperacion: roundToTwo(totalMontoOperacion),
        totalPagar: roundToTwo(totalPagar),
        totalNoGravado: roundToTwo(totalNoGravado),
        otrosImpuestos: roundToTwo(otrosImpuestos),
        resumenTributos: resumenTributos,
        descuentoGlobal: roundToTwo(descuentoGlobal),
        descuentoGlobalError: descuentoGlobalError,
      })
    )
  }

  
export const facturacionProductosVerificacionServicios = () => async(dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
  const productos = getState().facturacion.arrayProductos;
  const servicios = productos.filter((el) => el.tipo === "s");
  return servicios.length > 0;
}

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const facturacionFormProductoValidacionesOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    const edit = getState().facturacion.modals.activeEditar
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'descripcion':
        message = validators.validacionEsRequerido(value, message, 'Descripción', 'requerida')
        break
      case 'cantidad':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMinimo(value, 0)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)
        break
      case 'precio':
      case 'precioConIva':
        if (name === 'precioConIva') name = 'precio'
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMinimo(value, 0)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)
        break
      case 'tipoDescuento':
        message = validators.validacionEsRequerido(value, message)
        break
      case 'descuento':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)

        // Validación de Descuento
        if (!message) {
          const {tipoDescuento, precio, cantidad} = edit
            ? getState().facturacion.formProductosEdit
            : getState().facturacion.formProductos
          const {messageError, ms} = validacionDescuento(value, tipoDescuento!, precio!, cantidad!)
          if (messageError && !edit) dispatch(generalOpenModalError(messageError))
          message = ms
        }

        break
      default:
        break
    }

    if (edit) dispatch(facturacionFormProductoAddErrorEdit({[name]: message}))
    else dispatch(facturacionFormProductoAddError({[name]: message}))
  }

const validacionDescuento = (
  value: string,
  tipoDescuento: string,
  precio: string,
  cantidad: string
) => {
  let messageError = '',
    ms = ''
  let num = parseFloat(value)
  if (tipoDescuento === 'porcentaje') {
    if (num > 100) {
      messageError = 'El Descuento no puede ser mayor a 100%'
      ms = 'Desc. incorrecto'
    }
  } else {
    if (precio && cantidad) {
      let subtotal = Number(precio) * Number(cantidad)
      if (num > subtotal) {
        messageError = 'El Descuento no debe ser mayor al subtotal'
        ms = 'Desc. incorrecto'
      }
    }
  }
  return {messageError, ms}
}
